import { client } from "./axiosConfig";

export const getLanguagePref = (userId) => {
    return client.get(`/user/${userId}/language`);
};

export const updateLanguagePref = (data) => {
    return client.post("/user/language", data);
};